import { NgModule } from '@angular/core';
import { BranchesCoreModule } from './branches-core';
import { JumbleCoreModule } from './jumble-core';
import { MtcCoreModule } from './mtc-core';
import { OrderingCoreModule } from './ordering-core';
import { QuestionCoreModule } from './question-core';
import { SequenceCoreModule } from './sequence-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    BranchesCoreModule,
    JumbleCoreModule,
    MtcCoreModule,
    OrderingCoreModule,
    QuestionCoreModule,
    SequenceCoreModule,
  ],
})
export class Level2GameCoreModule {}
